import { combineReducers } from "redux";
import app from './app';
import loader from './loader'

export default combineReducers({
  app,
  loader
});
